import { Flex, AspectRatioKeeper, Image, Typography, DsmColor, omitText, Link } from '@kohler-dsm-library/kohler-core';
import clsx from 'clsx';
import React, { isValidElement } from 'react';
import { VideoCard } from '../VideoCard/VideoCard.mjs';
import classes from './ContentCard.module.css.mjs';

const ContentCard = ({
  aspectRatio,
  eyebrow,
  image,
  video,
  title,
  description,
  CTA,
  CTAs,
  isPortrait = false
}) => {
  return /* @__PURE__ */ React.createElement(Flex, { direction: "column", className: clsx(classes.contentCard, isPortrait && classes.portraitCard) }, /* @__PURE__ */ React.createElement(AspectRatioKeeper, { aspectRatio }, image && !video && /* @__PURE__ */ React.createElement(Image, { ...image, position: "absolute", inset: "0" }), video && /* @__PURE__ */ React.createElement(VideoCard, { video })), /* @__PURE__ */ React.createElement(Flex, { direction: "column", gap: 15 }, /* @__PURE__ */ React.createElement(Flex, { direction: "column", gap: 5 }, eyebrow && /* @__PURE__ */ React.createElement(
    Typography,
    {
      component: eyebrow.component || "p",
      ...omitText(eyebrow),
      size: "label-medium-m",
      textColor: DsmColor.ContentTertiary
    },
    eyebrow.text
  ), /* @__PURE__ */ React.createElement(Typography, { component: title.component || "h3", ...omitText(title), size: "h5", textColor: DsmColor.ContentPrimary }, title.text)), !isPortrait && description && /* @__PURE__ */ React.createElement(
    Typography,
    {
      component: isValidElement(description.text) ? "div" : description.component || "p",
      ...omitText(description),
      size: "paragraph-medium",
      textColor: DsmColor.ContentSecondary
    },
    description.text
  ), !isPortrait && CTA && /* @__PURE__ */ React.createElement(Link, { ...omitText(CTA), width: "fit-content", size: "medium" }, CTA.text), !isPortrait && CTAs && CTAs.length > 0 && /* @__PURE__ */ React.createElement(Flex, { gap: "10px 20px", wrap: "wrap" }, CTAs.map((link, index) => /* @__PURE__ */ React.createElement(Link, { key: link?.text?.toString() || index, ...omitText(link), size: "medium", width: "fit-content" }, link.text)))));
};

export { ContentCard };
